import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  selectAccountNameFirst,
  selectAccountRole,
  selectAccountRegistrationAction,
  selectAccountBalance,
  fetchMeActions,
  resendActivationEmailRequest,
  selectAccountId,
  selectRegistrationDocumentsRejectReason,
  selectAccountCreatedAt,
  selectAccount
} from '../../../features/auth/ducks';
import { settingKeys } from '../../../common/enums';
import { selectSettingNumeric } from '../../../features/settings/ducks';
import { selectLoans } from '../../loans/ducks';
import DashboardLayout from '../components/DashboardLayout';

const AUTO_REFRESH_COOLDOWN_MS = 10 * 60 * 1000;

const mapStateToProps = state => ({
  accountCreated: selectAccountCreatedAt(state),
  accountId: selectAccountId(state),
  nameFirst: selectAccountNameFirst(state),
  accountRole: selectAccountRole(state),
  accountBalance: selectAccountBalance(state),
  registrationAction: selectAccountRegistrationAction(state),
  registrationDocumentsRejectReason: selectRegistrationDocumentsRejectReason(state),
  maxOpenLoans: selectSettingNumeric(state, settingKeys.MAX_NUMBER_OF_OPEN_LOANS),
  loans: selectLoans(state),
  account: selectAccount(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchMe: fetchMeActions.request,
      resendActivationEmail: resendActivationEmailRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class DashboardWrapper extends Component {
  lastAutoRefreshAt = 0;

  static propTypes = {
    children: PropTypes.node.isRequired,
    nameFirst: PropTypes.string.isRequired,
    accountRole: PropTypes.string.isRequired,
    accountBalance: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired,
    registrationAction: PropTypes.string,
    registrationDocumentsRejectReason: PropTypes.string,
    maxOpenLoans: PropTypes.number,
    account: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.refreshAccount(true);
    window.addEventListener('focus', this.handleWindowFocus);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.handleWindowFocus);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleWindowFocus = () => {
    this.refreshAccount();
  };

  handleVisibilityChange = () => {
    if (!document.hidden) {
      this.refreshAccount();
    }
  };

  refreshAccount = (force = false) => {
    const now = Date.now();
    const { actions, accountId } = this.props;

    if (!accountId) {
      return;
    }

    if (!force && now - this.lastAutoRefreshAt < AUTO_REFRESH_COOLDOWN_MS) {
      return;
    }

    this.lastAutoRefreshAt = now;
    actions.fetchMe({ accountId });
  };

  handleResendActivationEmail = () => {
    const { actions, accountId } = this.props;
    actions.resendActivationEmail({ accountId });
  };

  render() {
    const {
      children,
      nameFirst,
      accountRole,
      accountBalance,
      registrationAction,
      registrationDocumentsRejectReason,
      accountCreated,
      account,
    } = this.props;

    return (
      <DashboardLayout
        nameFirst={nameFirst}
        accountRole={accountRole}
        accountBalance={accountBalance}
        registrationAction={registrationAction}
        registrationDocumentsRejectReason={registrationDocumentsRejectReason}
        resendActivationEmail={this.handleResendActivationEmail}
        accountCreated={new Date(accountCreated)}
        allowNewLoans={account.allowNewLoans}
        registrationStatus={account.registrationStatus}
      >
        {children}
      </DashboardLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/containers/DashboardWrapper.js